import formatDate from '@/services/general/formatDate';

export default function generateDataExcel(produitsFace, i18n) {
  const dataExcel = [];
  dataExcel.push({
    code: i18n.t('exportExcelFace.columnExcel.code'),
    libelle: i18n.t('exportExcelFace.columnExcel.libelle'),
    format: i18n.t('exportExcelFace.columnExcel.format'),
    materielType: i18n.t('exportExcelFace.columnExcel.materiel'),
    adresse: i18n.t('exportExcelFace.columnExcel.adresse'),
    codePostal: i18n.t('exportExcelFace.columnExcel.codePostal'),
    ville: i18n.t('exportExcelFace.columnExcel.ville'),
    sousReseau: i18n.t('exportExcelFace.columnExcel.sousReseau'),
    dateDebut: i18n.t('exportExcelFace.columnExcel.dateDebut'),
    dateFin: i18n.t('exportExcelFace.columnExcel.dateFin'),
    localisation: i18n.t('exportExcelFace.columnExcel.localisation'),
    angle: i18n.t('exportExcelFace.columnExcel.angle'),
    eclaire: i18n.t('exportExcelFace.columnExcel.eclaire'),
    latitude: i18n.t('exportExcelFace.columnExcel.latitude'),
    longitute: i18n.t('exportExcelFace.columnExcel.longitude'),
  });
  produitsFace.forEach((produitFace) => {
    const produit = produitFace.produit;
    if (!produit.produitFace) { return; }
    const ligneExcel = {
      code: produit.reference,
      libelle: produit.libelle,
      format: produit.produitFace.format,
      materielType: produit.produitFace.materielType,
      adresse: produitFace.adresse,
      codePostal: produit.produitFace.adresse.codePostal,
      ville: produit.produitFace.adresse.ville,
      sousReseau: produitFace.sousReseauExport,
      dateDebut: formatDate(produitFace.dateDebut),
      dateFin: formatDate(produitFace.dateFin),
      localisation: produit.produitFace.localisation,
      angle: produit.produitFace.angleDeVision,
      eclaire: produit.produitFace.eclaire ? i18n.t('exportExcelFace.yes') : i18n.t('exportExcelFace.no'),
      latitude: produit.produitFace.adresse.latitude,
      longitute: produit.produitFace.adresse.longitude,
    };
    dataExcel.push(ligneExcel);
  });
  return dataExcel;
}
